export const SetAppliedJobs = (data) => {
  return {
    type: "SETAPPLIEDJOBS",
    payload: data
  };
}

export const DestroyAppliedJobs = () => {
  return {
    type: "DESTROYAPPLIEDJOBS"
  }
}

export const UpdateAppliedJobs = (data) => {
  return {
    type: "UPDATEAPPLIEDJOBS",
    payload: data
  }
}
